import { useState } from 'react';

import type { IAccordionItem } from '@/DesignSystem/Model/DataModel';

interface IProps<T> {
  items: IAccordionItem<T>[];
  defaultSelected?: T[];
  multiple?: boolean;
}
export const useMultiAccordion = <T>({ items, defaultSelected, multiple }: IProps<T>) => {
  const [selected, setSelected] = useState<T[]>(defaultSelected ?? []);

  const onToggle = (tabId: T) => {
    if (!multiple) {
      setSelected(prevState => {
        if (prevState?.[0] === tabId) {
          return [];
        }

        return [tabId];
      });
      return;
    }
    setSelected(prevState => {
      const find = prevState.find(item => item === tabId);
      if (find) return prevState.filter(item => item !== tabId);
      return [...prevState, tabId];
    });
  };

  return {
    selected,
    onToggle,
    items,
  };
};

export type IUseMultiAccordionType<T> = ReturnType<typeof useMultiAccordion<T>>;
